/**elementui 以用外链形式加载，不用import css文件 */
import ElementUI from "element-ui";
import Vue from "vue";
ElementUI.Select.props.popperAppendToBody.default = false;
Vue.use(ElementUI);